// Legal Notice / Mentions Légales - drbooking
// Obligatoire en Europe

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { ArrowLeft, Building2, Mail, Globe, Server, Shield } from 'lucide-react';

const LegalNotice = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white dark:from-slate-900 dark:to-slate-800">
      {/* Header */}
      <div className="bg-slate-800 text-white py-12">
        <div className="max-w-4xl mx-auto px-4">
          <Button
            variant="ghost"
            className="text-white hover:bg-slate-700 mb-4"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Retour
          </Button>
          <div className="flex items-center gap-3">
            <Building2 className="h-10 w-10" />
            <div>
              <h1 className="text-3xl font-bold">Mentions Légales</h1>
              <p className="text-slate-300">Informations légales obligatoires</p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-12">
        <div className="space-y-8">
          
          {/* Editor */}
          <section className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm border border-slate-200 dark:border-slate-700">
            <h2 className="flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white mb-4">
              <Building2 className="h-5 w-5 text-blue-600" />
              Éditeur du site
            </h2>
            <div className="space-y-2 text-slate-600 dark:text-slate-300">
              <p><strong>Nom :</strong> drbooking</p>
              <p><strong>Forme juridique :</strong> [À compléter]</p>
              <p><strong>Siège social :</strong> Luxembourg</p>
              <p><strong>Numéro d'immatriculation :</strong> [À compléter]</p>
              <p><strong>Capital social :</strong> [À compléter]</p>
              <p><strong>Numéro de TVA :</strong> [À compléter]</p>
            </div>
          </section>

          {/* Director */}
          <section className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm border border-slate-200 dark:border-slate-700">
            <h2 className="flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white mb-4">
              <Shield className="h-5 w-5 text-blue-600" />
              Directeur de la publication
            </h2>
            <div className="space-y-2 text-slate-600 dark:text-slate-300">
              <p><strong>Nom :</strong> [À compléter]</p>
              <p><strong>Qualité :</strong> Gérant / Directeur</p>
            </div>
          </section>

          {/* Contact */}
          <section className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm border border-slate-200 dark:border-slate-700">
            <h2 className="flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white mb-4">
              <Mail className="h-5 w-5 text-blue-600" />
              Contact
            </h2>
            <div className="space-y-2 text-slate-600 dark:text-slate-300">
              <p><strong>Email :</strong> contact@drbooking.pro</p>
              <p><strong>Site web :</strong> https://drbooking.pro</p>
              <p><strong>Téléphone :</strong> [À compléter]</p>
            </div>
          </section>

          {/* Hosting */}
          <section className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm border border-slate-200 dark:border-slate-700">
            <h2 className="flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white mb-4">
              <Server className="h-5 w-5 text-blue-600" />
              Hébergement
            </h2>
            <div className="space-y-2 text-slate-600 dark:text-slate-300">
              <p><strong>Hébergeur :</strong> Emergent Labs / Cloudflare</p>
              <p><strong>Adresse :</strong> Services cloud distribués</p>
              <p><strong>Site web :</strong> https://emergentagent.com</p>
            </div>
          </section>

          {/* Intellectual Property */}
          <section className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm border border-slate-200 dark:border-slate-700">
            <h2 className="flex items-center gap-2 text-xl font-bold text-slate-900 dark:text-white mb-4">
              <Globe className="h-5 w-5 text-blue-600" />
              Propriété intellectuelle
            </h2>
            <div className="text-slate-600 dark:text-slate-300 space-y-4">
              <p>
                L'ensemble du contenu du site drbooking (textes, images, graphismes, logo, icônes, 
                sons, logiciels, etc.) est protégé par les lois en vigueur sur la propriété intellectuelle.
              </p>
              <p>
                Toute reproduction, représentation, modification, publication, adaptation de tout ou partie 
                des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf 
                autorisation écrite préalable de drbooking.
              </p>
              <p>
                Toute exploitation non autorisée du site ou de l'un quelconque des éléments qu'il contient 
                sera considérée comme constitutive d'une contrefaçon et poursuivie conformément aux 
                dispositions légales en vigueur.
              </p>
            </div>
          </section>

          {/* Data Protection */}
          <section className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm border border-slate-200 dark:border-slate-700">
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-4">
              Protection des données personnelles
            </h2>
            <div className="text-slate-600 dark:text-slate-300 space-y-4">
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi 
                Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, de suppression 
                et d'opposition aux données personnelles vous concernant.
              </p>
              <p>
                Pour exercer ces droits ou pour toute question relative à la protection de vos données, 
                vous pouvez nous contacter à : <strong>privacy@drbooking.pro</strong>
              </p>
              <p>
                Pour plus d'informations, consultez notre{' '}
                <a href="/privacy" className="text-blue-600 hover:underline">Politique de Confidentialité</a>.
              </p>
            </div>
          </section>

          {/* Cookies */}
          <section className="bg-white dark:bg-slate-800 rounded-xl p-6 shadow-sm border border-slate-200 dark:border-slate-700">
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-4">
              Cookies
            </h2>
            <div className="text-slate-600 dark:text-slate-300 space-y-4">
              <p>
                Le site drbooking utilise des cookies pour améliorer l'expérience utilisateur et 
                analyser le trafic. Vous pouvez gérer vos préférences en matière de cookies à tout moment.
              </p>
              <p>
                Types de cookies utilisés :
              </p>
              <ul className="list-disc pl-6 space-y-1">
                <li><strong>Cookies essentiels :</strong> nécessaires au fonctionnement du site</li>
                <li><strong>Cookies analytiques :</strong> pour comprendre l'utilisation du site</li>
                <li><strong>Cookies de session :</strong> pour maintenir votre connexion</li>
              </ul>
            </div>
          </section>

          {/* Applicable Law */}
          <section className="bg-blue-50 dark:bg-slate-800 rounded-xl p-6 border border-blue-200 dark:border-slate-700">
            <h2 className="text-xl font-bold text-slate-900 dark:text-white mb-4">
              Droit applicable et juridiction compétente
            </h2>
            <div className="text-slate-600 dark:text-slate-300">
              <p>
                Les présentes mentions légales sont régies par le droit luxembourgeois. En cas de litige, 
                et après échec de toute tentative de recherche d'une solution amiable, les tribunaux 
                luxembourgeois seront seuls compétents.
              </p>
            </div>
          </section>

          {/* Last update */}
          <p className="text-center text-sm text-slate-500 dark:text-slate-400">
            Dernière mise à jour : 28 Mars 2026
          </p>

        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
